import React from 'react';
import TitleText from './TitleText';
import {
	Box,
	Container,
	Grid,
	Drawer,
	makeStyles,
	Divider,
	Avatar,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Chip,
} from '@material-ui/core';
import BodyText from './BodyText';
const Footer = () => {
	return (
		<>
			<Box>
				<BodyText
					three
					textStyle={{
						textAlign: 'right',
						color: 'white',
						fontFamily: 'Roboto Serif, sans-serif',
					}}>
					Copyright ©2022, All Rights Reserved. Powered by Arya Aviation Pvt.
					Ltd.
				</BodyText>
			</Box>
		</>
	);
};

export default Footer;
